import { useFormContext } from 'react-hook-form';
import { contactsFromDetailsResponse, createContactField } from '@/app/(main)/client-detail/utils/contacts';
import type { ErrorResponse } from '@/types/apiTypes';
import type { EditClientData } from '@/types/clientsApiTypes';
import { setBEFieldError } from '@/utils/setBEFieldError';
import { useEditClientMutation } from '../../../hooks/useEditClientMutation';
import { useGetPayloadData } from '../../components/ClientAutoSaveOnBlur/hooks/useGetPayloadData';

export const useUpdateClientByFieldName = () => {
  const { mutateAsync: editClientMutation } = useEditClientMutation();
  const { setError, setValue } = useFormContext();
  const { getPayloadData, getPassengerId } = useGetPayloadData();

  const updateClientByFieldName = async (fieldName: string, fieldValue: unknown, onSuccess?: () => void) => {
    const passengerId = getPassengerId(fieldName);

    try {
      const payloadData = getPayloadData(fieldName, fieldValue);
      if (!payloadData) {
        onSuccess?.();
        return undefined;
      }

      return await editClientMutation(
        {
          data: payloadData as Partial<EditClientData>,
          clientId: passengerId,
        },
        {
          onSuccess: (response) => {
            const contact = createContactField(fieldName);
            const lists = contactsFromDetailsResponse(response);
            if (contact && lists) {
              setValue(`${contact.prefix}.client.crm_emails`, lists.emails, { shouldDirty: false });
              setValue(`${contact.prefix}.client.crm_phones`, lists.phones, { shouldDirty: false });
            }
            onSuccess?.();
          },
        }
      );
    } catch (error) {
      setBEFieldError(error as ErrorResponse<unknown>, setError);
      return undefined;
    }
  };

  return { updateClientByFieldName };
};